import React from 'react';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import NumberInputDashboard from "../../CustomInputs/NumberInputDashboard";

const ItemTotalProfit = ({label, value, currency, iconUrl, percentage, suffix, onClick}) => {
  return (
    <Box 
      width={{xs: '100%', sm: '49%', md: '32.5%', lg: '24%'}} 
      mr='10px' 
      mb='10px'
      sx={{ cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
    >
      <Card sx={{ height: '100%' }}>
        <CardContent>
          <Box display='flex' justifyContent='space-between' alignItems='center' mb='10px' minHeight='25px'>
            {/* Support both string and React element for label */}
            {typeof label === 'string' ? (
              <Typography
                sx={{fontSize: 14}}
                color="text.secondary"
                gutterBottom
              >
                {label}
              </Typography>
            ) : (
              <Box sx={{ fontSize: 14, color: 'text.secondary' }}>
                {label}
              </Box>
            )}
            {iconUrl && (
              <img src={iconUrl} alt="" width='25px' height='25px'/>
            )}
          </Box>
          <Box display='flex' alignItems='center' gap='8px' flexWrap='wrap'>
            <NumberInputDashboard
              value={value}
              currency={currency}
            />
            {suffix && (
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '14px'
                }}
              >
                {suffix}
              </Typography>
            )}
            {percentage !== undefined && (
              <Typography 
                variant="body2" 
                sx={{ 
                  color: parseFloat(percentage) >= 0 ? 'green' : 'red',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                ({percentage}%)
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ItemTotalProfit;